import React from 'react'
import ContactImage from './ContactImage'
import ContactText from './ContactText'
import Scroll from '../../pages/Scroll/Scroll'
import Footer from '../../pages/Footer/Footer'
import CreateForm from '../../pages/Form/CreateForm'

const OurContact = () => {
  return (
    <>
    <ContactImage/>
    <ContactText/>
    <CreateForm/>
    <Scroll/>
    <Footer/>
    </>
  )
}

export default OurContact
